const components = {
  motion: [
    'Motion',
    'MotionPresence',
  ],
}

export { components }
export type Components = keyof typeof components

export const utilities = {
  utilities: [
    'useAnimate',
    'useAnimations',
  ],
}

export type Utilities = keyof typeof utilities
